import React from "react";
import "./About.css";

export default function About() {
  return (
    <div className='about-container'>
      <div className='container'>
        {/* Header */}
        <div className='about-header'>
          <h1>About Pandemic Relief Connect</h1>
          <p>Connecting communities in times of crisis through technology and compassion</p>
        </div>

        {/* Hero Section */}
        <div className='about-hero-section'>
          <div className='hero-content'>
            <div className='hero-text'>
              <h2>Our Story</h2>
              <p>
                Pandemic Relief Connect was born from the understanding that during crisis situations, 
                communities need efficient ways to support each other. We bridge the gap between those 
                who need help and those who can provide it through innovative technology solutions.
              </p>
              <p>
                Our platform enables seamless coordination of relief efforts, ensuring that essential 
                supplies reach the people who need them most, when they need them most.
              </p>
            </div>
            <div className='hero-image'>
              <i className='fa fa-heart fa-5x'></i>
            </div>
          </div>
        </div>

        {/* Mission Section */}
        <div className='mission-section'>
          <h2>Our Mission</h2>
          <p className='mission-text'>
            To create a seamless platform that enables efficient distribution of essential supplies
            during emergencies, ensuring no one is left behind in times of need.
          </p>
        </div>

        {/* Services Section */}
        <div className='services-section'>
          <h2>Our Services</h2>
          <div className='services-grid'>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fa fa-truck fa-3x'></i>
              </div>
              <h4>Emergency Supply Distribution</h4>
              <p>
                Coordinating the delivery of essential items like food, medicine, 
                and hygiene products to affected communities during crises.
              </p>
            </div>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fa fa-users fa-3x'></i>
              </div>
              <h4>Volunteer Coordination</h4>
              <p>
                Connecting volunteers with opportunities to help, from donation 
                collection to distribution and community support services.
              </p>
            </div>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fa fa-map-marker fa-3x'></i>
              </div>
              <h4>Location-Based Matching</h4>
              <p>
                Smart matching system that connects donors and recipients based 
                on proximity and specific needs for efficient resource allocation.
              </p>
            </div>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fa fa-mobile fa-3x'></i>
              </div>
              <h4>Mobile App Platform</h4>
              <p>
                User-friendly mobile application for easy donation requests, 
                pickup scheduling, and real-time tracking of relief efforts.
              </p>
            </div>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fa fa-shield fa-3x'></i>
              </div>
              <h4>Safety & Verification</h4>
              <p>
                Ensuring safe and hygienic collection and distribution processes 
                with verified volunteers and contactless delivery options.
              </p>
            </div>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fa fa-bar-chart fa-3x'></i>
              </div>
              <h4>Impact Tracking</h4>
              <p>
                Real-time analytics and reporting to track the impact of relief 
                efforts and optimize resource distribution strategies.
              </p>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className='values-section'>
          <h2>Our Values</h2>
          <div className='values-grid'>
            <div className='value-item'>
              <i className='fa fa-handshake-o fa-2x'></i>
              <h5>Community First</h5>
              <p>Every decision we make prioritizes the wellbeing of our communities.</p>
            </div>
            <div className='value-item'>
              <i className='fa fa-lightbulb-o fa-2x'></i>
              <h5>Innovation</h5>
              <p>Leveraging technology to create efficient solutions for complex problems.</p>
            </div>
            <div className='value-item'>
              <i className='fa fa-eye fa-2x'></i>
              <h5>Transparency</h5>
              <p>Open communication and clear processes build trust in our platform.</p>
            </div>
            <div className='value-item'>
              <i className='fa fa-clock-o fa-2x'></i>
              <h5>Urgency</h5>
              <p>Understanding that in emergencies, every moment counts for those in need.</p>
            </div>
          </div>
        </div>

        {/* Impact Section */}
        <div className='impact-section'>
          <h2>Our Impact</h2>
          <div className='impact-stats'>
            <div className='impact-stat'>
              <h3 className='stat-number'>10,000+</h3>
              <p>Families Helped</p>
            </div>
            <div className='impact-stat'>
              <h3 className='stat-number'>500+</h3>
              <p>Active Volunteers</p>
            </div>
            <div className='impact-stat'>
              <h3 className='stat-number'>50+</h3>
              <p>Partner Organizations</p>
            </div>
            <div className='impact-stat'>
              <h3 className='stat-number'>25</h3>
              <p>Cities Covered</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className='cta-section'>
          <h2>Join Our Mission</h2>
          <p className='cta-text'>
            Together, we can build stronger, more resilient communities. 
            Whether you want to donate, volunteer, or partner with us, there's a place for you.
          </p>
          <div className='cta-buttons'>
            <a href='/donate' className='btn btn-danger'>Start Donating</a>
            <a href='/contact' className='btn btn-outline-danger'>Get Involved</a>
          </div>
        </div>
      </div>
    </div>
  );
}